import React from "react";
import styled from "@emotion/styled";
import { Flex, GroupIcon, ImportantInfoCard, Loader, Text } from "src/components";
import { colors } from "src/theme";
import { i18n, mediaQuery } from "src/common";
import { Card } from "./card";

const CardStyle = styled(Card)({
  padding: '16px',

  [mediaQuery('tablet')]: {
    padding: '24px'
  },

  [mediaQuery('laptopL')]: {
    padding: '40px',
  }
})

const TextStyle = styled(Text)({
  [mediaQuery('laptopL')]: {
    textAlign: 'center',
  }
})

export interface BestPriceCardProps {
  price?: number;
  className?: string;
}

export const BestPriceCard = ({ price, className }: BestPriceCardProps) => (
  <CardStyle className={className}>
    <Flex vertical gap={'12px'}>
      <TextStyle type="large" bold>{i18n.t('components.cards.bestPriceCard.title')}</TextStyle>
      {!price && <Loader />}
      {price && <ImportantInfoCard price={price} />}
      <Flex gap={8}>
        <GroupIcon color={colors.icon5} width={12} height={12} />
        <TextStyle type="micro" color={colors.text3}>{i18n.t('components.cards.bestPriceCard.description')}</TextStyle>
      </Flex>
    </Flex>
  </CardStyle>
)

